import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [

  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/configuracion",
    name: "Configuracion",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "configuracion" */ "../views/Configuracion.vue"),
  },
  {
    path: "/tipopoliza",
    name: "PolizasTipo",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "tipopoliza" */ "../views/PolizasTipo.vue"),
  },
  {
    path: "/cfdis",
    name: "Listacfdi",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "cfdis" */ "../views/Listacfdi.vue"),
  },
  {
    path: "/cfdisvisor",
    name: "Listacfdivisor",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "Listacfdisvisor" */ "../views/Listacfdivisor.vue"),
  },
  {
    path: "/cfdisconfig",
    name: "Configuracioncfdis",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "Configuracioncfdis" */ "../views/Configuracioncfdis.vue"),
  },
  {
    path: "/cfdidescargaaut",
    name: "Cfdidescargaaut",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "Cfdidescargaws" */ "../views/Cfdidescargaautomatica.vue"),
  },
  
  {
    path: "/cfdidescargaws",
    name: "Cfdidescargaws",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "Cfdidescargaws" */ "../views/Cfdidescargaservice.vue"),
  },
  {
    path: "/Listadodiot",
    name: "Diot2025",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "listadodiot" */ "../views/Listadodiot.vue"),
  },
  {
    path: "/Listacfdippd",
    name: "Listacfdippd",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "listadodiot" */ "../views/Listacfdippd.vue"),
  },
  {
    path: "/cfdidescarga",
    name: "Cfdidescarga",
    meta: {
      auth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "cfdidescarga" */ "../views/Cfdidescarga.vue"
      ),
  },
  {
    path: "/cfdisadd",
    name: "Cfdiimportar",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "cfdisadd" */ "../views/Cfdiimportar.vue"),
  },
  {
    path: "/ejercicios",
    name: "Ejercicios",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "ejercicios" */ "../views/Ejercicios.vue"),
  },
  {
    path: "/ejerciciocierre",
    name: "Ejerciciocierre",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "ejerciciocierre" */ "../views/EjercicioCierre.vue"),
  },
  {
    path: "/empresanuevo",
    name: "Empresanuevo",
    meta: {
      auth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "empresanuevo" */ "../views/EmpresaNuevo.vue"
      ),
  },
  {
    path: "/empresaimportar",
    name: "Empresaimportar",
    meta: {
      auth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "empresanuevo" */ "../views/EmpresaImportar.vue"
      ),
  },
  {
    path: "/cuentasimportar",
    name: "Cuentasimportar",
    meta: {
      auth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "cuentasimportar" */ "../views/Cuentasimportar.vue"
      ),
  },
  {
    path: "/poliza",
    name: "Poliza",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "poliza" */ "../views/Poliza.vue"),
  },

  {
    path: "/repbalanza",
    name: "Balanza",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "repbalanza" */ "../views/Repbalanza.vue"),
  },
  {
    path: "/repbalance",
    name: "Balance",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "repbalance" */ "../views/Repbalance.vue"),
  },
  {
    path: "/represultados",
    name: "Resultados",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "represultados" */ "../views/Represultados.vue"),
  },
  {
    path: "/repauxiliar",
    name: "Auxiliar",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "repauxiliar" */ "../views/Repauxiliar.vue"),
  },
  {
    path: "/auxiliarcuenta",
    name: "AuxiliarCuenta",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "auxiliarcuenta" */ "../views/AuxiliarCuenta.vue"),
  },
  {
    path: "/repdiario",
    name: "Diario",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "repdiario" */ "../views/Repdiario.vue"),
  },
  {
      path: "/polizavista",
      name: "Polizavista",
      meta: {
        auth: true,
      },
      component: () =>
        import(/* webpackChunkName: "polizavista" */ "../views/Polizavista.vue"),
    },

  {
    path: "/empresas",
    name: "Empresas",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "empresas" */ "../views/EmpresaSelect.vue"),
  },
  {
    path: "/saldoscuentas",
    name: "Saldoscuentas",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(
        /* webpackChunkName: "saldoscuentas" */ "../views/Saldosiniciales.vue"
      ),
  },
  {
    path: "/saldoscuenta",
    name: "Saldoscuenta",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(
        /* webpackChunkName: "saldoscuenta" */ "../views/Saldosdecuenta.vue"
      ),
  },
  {
    path: "/cuentas",
    name: "Cuentas",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(/* webpackChunkName: "cuentas" */ "../views/Cuentas.vue"),
  },
  {
    path: "/cuentasrfc",
    name: "Cuentasrfc",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(/* webpackChunkName: "cuentasrfc" */ "../views/CuentasRFC.vue"),
  },
  {
    path: "/contabilidadelectronica",
    name: "Contabilidadelectrónica",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(/* webpackChunkName: "contabilidadelectronica" */ "../views/Contabilidadelectronica.vue"),
  },
  {
    path: "/polizas",
    name: "Polizas",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(/* webpackChunkName: "polizas" */ "../views/PolizaListado.vue"),
  },
  {
    path: "/polizas/:ayear/:ames",
    name: "Polizasyear",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(/* webpackChunkName: "polizas" */ "../views/PolizaListado.vue"),
  },
  {
    path: "/polizasplantillas",
    name: "Polizasplantillas",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(/* webpackChunkName: "polizasplantillas" */ "../views/PolizasPlantillas.vue"),
  },  
  {
    path: "/polizasplantillasimportar",
    name: "Polizasplantillasimportar",
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "polizasplantillas" */ "../views/PolizasPlantillasImportar.vue"),
  },  
  
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/registro",
    name: "Registro",
    component: () =>
      import(/* webpackChunkName: "registro" */ "../views/Registro.vue"),
  },
  {
    path: "/forgotpassword",
    name: "Forgotpassword",
    component: () =>
      import(/* webpackChunkName: "Forgotpassword" */ "../views/Forgotpassword.vue"),
  },
  {
    path: "/resetpassword",
    name: "Resetpassword",
    component: () =>
      import(/* webpackChunkName: "Resetpassword" */ "../views/Resetpassword.vue"),
  },
  {
    path: "/sendverifyemail",
    name: "SendVerifyemail",
    component: () =>
      import(/* webpackChunkName: "Verifyemail" */ "../views/SendVerifyEmail.vue"),
  },
  {
    path: "/verifyemail",
    name: "Verifyemail",
    component: () =>
      import(/* webpackChunkName: "Verifyemail" */ "../views/VerifyEmail.vue"),
  },
  {
    path: "/movbancos",
    name: "Movimientosbancarios",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(/* webpackChunkName: "movbancos" */ "../views/BancosMovtosListado.vue"),
  },  
  {
    path: "/cuentasbancarias",
    name: "Cuentasbancarias",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(/* webpackChunkName: "cuentasbancarias" */ "../views/Cuentasbancarias.vue"),
  },
  {
    path: "/inventarios",
    name: "Inventarios",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(/* webpackChunkName: "inventarios" */ "../views/Inventarios.vue"),
  },
  { 
    path: "/diotperiodos",
    name: "Diotperiodos",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(/* webpackChunkName: "diotperiodos" */ "../views/Diotperiodos.vue"),
  },
  { 
    path: "/rsaldos",
    name: "RSaldos",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(/* webpackChunkName: "diotperiodos" */ "../views/Restructura.vue"),
  },

  { 
    path: "/chartdetalle",
    name: "Chartdetalle",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(/* webpackChunkName: "diotperiodos" */ "../views/Chartdetalle.vue"),
  },

  { 
    path: "/IVA",
    name: "IVA",
    meta: {
      auth: true,
    },
    
    component: () =>
      import(/* webpackChunkName: "IVA" */ "../views/ListaIVA.vue"),
  },
  
];

const router = createRouter({
  history: process.env.NODE_ENV === 'production' ? createWebHistory('/web/') : createWebHistory('/'),
 // history: createWebHistory('/web/'),
  //history: createWebHistory('/ic/'),
  routes,
});

router.beforeEach((to, from, next) => {
  //console.log(from);
  const loggedIn = localStorage.getItem("user");
  const loggedEmpresa = localStorage.getItem("empresa");
  //console.log(loggedIn);
  //console.log(loggedEmpresa);
  if (to.matched.some((record) => record.meta.auth) && !loggedIn) {
    console.log("vamos a login");
    next("/login");
    return;
  }
  if (loggedIn) {
    if (!loggedEmpresa) {
      console.log("aqui deberiamos mandar a seleccionar la empresa");
    }
  }
  next();
});

export default router;
